/**
 * The platform's shortcut modifier symbol, for labelling keyboard
 * shortcuts in tooltips and menus.
 *
 * Shortcut handlers all accept `metaKey || ctrlKey`, so the label is the
 * only thing that needs to know which platform the coach is on.
 *
 * @returns {'⌘' | 'CTRL'}
 */
const getModifierKeyLabel = () => (
  typeof navigator !== 'undefined' && /Mac/i.test(navigator.platform) ? '⌘' : 'CTRL'
);

export default getModifierKeyLabel;
